import React from 'react';

import Area from '@/components/apps/layouts/shared/Area';
import TransCustom from '@/components/apps/ui/transCustom/TransCustom';

/**
 * The brand line is the same in every language and is not press-kit copy, so
 * it lives here with the hero rather than in the copy module or the
 * translation catalogue.
 */
const BRAND_TAGLINE = { first: 'Sound into', second: 'Insight' } as const;

const TAGLINE_KEY =
  '양산 라인의 품질검사와 공공장소의 안전을 소리로 지키는 사운드 AI입니다.';

/**
 * ### HeroIntro
 *
 * The brand statement the home page opens on: the "Sound into Insight" line
 * and the one-sentence tagline under it, nothing more. Calls to action sit
 * with the claim and its evidence further down, where a visitor has a reason
 * to act on them.
 *
 * @returns The rendered hero intro element
 */
export default function HeroIntro() {
  return (
    <Area className="text-center">
      <h1 className="bg-[linear-gradient(99deg,#bacdff_0%,#d49dff_47%,#ff3ec9_100%)] bg-clip-text pb-[40px] font-dmSans text-[80px] font-medium leading-[100%] [-webkit-background-clip:text] [-webkit-text-fill-color:transparent] lg:pb-[clamp(40px,5vw,60px)] lg:text-[clamp(80px,8.333vw,160px)]">
        {BRAND_TAGLINE.first} <br className="hidden lg:block" />
        {BRAND_TAGLINE.second}
      </h1>
      <h2 className="text-[16px] font-medium leading-[140%] tracking-[-0.32px] text-apps-coreGrayWhite lg:text-[clamp(16px,1.667vw,20px)] lg:leading-[160%] lg:tracking-[-0.4px]">
        <TransCustom i18nKey={TAGLINE_KEY} />
      </h2>
    </Area>
  );
}
